import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

const useAuth = () => {
	const [loggedUser, setLoggedUser] = useState(null)
	const [alert, setAlert] = useState('')
	const [loading, setLoading] = useState(false)
	const [localUser, setLocalUser] = useState(null)

	const history = useHistory()

	const fetchUser = (formUser) => {
		setLoading(true)
		fetch('https://cp-node-api.herokuapp.com/api/auth/login', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(formUser),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data._id) {
					setLoggedUser(data)
				} else {
					setAlert(data.msg)
				}
				setLoading(false)
			})
	}

	useEffect(() => {
		if (loggedUser?.email) {
			const savedUser = localStorage.setItem(
				'user',
				JSON.stringify(loggedUser)
			)
			setLocalUser(savedUser)
		}
	}, [loggedUser])

	const logOut = () => {
		localStorage.removeItem('user')
		setLoggedUser(null)
		history.push('/login')
	}

	return {
		fetchUser,
		loggedUser,
		alert,
		loading,
		logOut,
		localUser,
	}
}

export default useAuth
